import {Component, HostBinding, Input} from '@angular/core';
import {Message} from '@catui/components/alert/types';

const componentBaseName = 'alert';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-alert',
  styleUrls: ['./alert.component.scss'],
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() message: Message;

  moreIsHidden = true;

  constructor() {
  }

  toggleMore() {
    this.moreIsHidden = !this.moreIsHidden;
    return false;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/alert/alert.component.ts